import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

import { actionNames } from '../../actions'
import { useHasEndedState } from '../../../firebase/hooks/useWebinarGlobalState'

const WebinarRoomMonitoring = () => {
  const ended = useHasEndedState()
  const dispatch = useDispatch()

  useEffect(() => {
    if (ended) {
      const now = new Date()
      const oneMinuteAfterEnded = ended.setTime(ended.getTime() + 1000 * 60)
      const isWithinOneMinute = now < oneMinuteAfterEnded
      if (isWithinOneMinute) {
        dispatch({ type: actionNames.ENDING_WEBINAR })
      }
    }
  }, [ended, dispatch])

  return null
}

export default WebinarRoomMonitoring
